import React from 'react';
import { Platform, ScrollView, type ScrollViewProps, type ViewStyle } from 'react-native';

const SCROLLBAR_CLASS = 'crewing-scrollbar';
const SCROLLBAR_STYLE_ID = 'crewing-horizontal-scrollbar-styles';

const webHorizontalScrollbarStyle = {
  overflowX: 'auto',
  scrollbarWidth: 'auto',
} as ViewStyle & React.CSSProperties;

const webVerticalScrollbarStyle = {
  overflowY: 'auto',
  scrollbarWidth: 'auto',
} as ViewStyle & React.CSSProperties;

if (Platform.OS === 'web' && typeof document !== 'undefined') {
  const style = document.getElementById(SCROLLBAR_STYLE_ID) ?? document.createElement('style');
  style.id = SCROLLBAR_STYLE_ID;
  style.textContent = `
    .${SCROLLBAR_CLASS}::-webkit-scrollbar {
      width: 12px;
      height: 12px;
    }
    .${SCROLLBAR_CLASS}::-webkit-scrollbar-thumb {
      min-width: 48px;
      min-height: 48px;
    }
  `;
  if (!style.parentElement) document.head.appendChild(style);
}

const ScrollViewWithClassName = ScrollView as React.ComponentType<
  ScrollViewProps & { className?: string }
>;

export const CrewingHorizontalScrollView: React.FC<ScrollViewProps> = ({ style, ...props }) =>
  React.createElement(ScrollViewWithClassName, {
    ...props,
    className: Platform.OS === 'web' ? SCROLLBAR_CLASS : undefined,
    style: [style, Platform.OS === 'web' ? webHorizontalScrollbarStyle : undefined],
  });

export const CrewingVerticalScrollView: React.FC<ScrollViewProps> = ({ style, ...props }) =>
  React.createElement(ScrollViewWithClassName, {
    ...props,
    className: Platform.OS === 'web' ? SCROLLBAR_CLASS : undefined,
    style: [style, Platform.OS === 'web' ? webVerticalScrollbarStyle : undefined],
  });